module.exports = __webpack_public_path__ + "img/9788990220950.428b3f07.jpg";